import { Workflow } from '../types';
import { getProcessedWorkflows } from '../utils';
import { useWorkflowContext } from '../../../contexts/WorkflowContext';

export const useWorkflows = () => {
  const {
    myWorkflows: contextMyWorkflows,
    companyWorkflows: contextCompanyWorkflows,
    loading,
    mySortConfig,
    setMySortConfig,
    companySortConfig,
    filters,
    setCompanySortConfig,
    setFilters,
  } = useWorkflowContext();

  // Use the workflows from context
  const myWorkflows = contextMyWorkflows;
  const companyWorkflows = contextCompanyWorkflows;

  // Sorting function for each table
  const handleSort = (key: keyof Workflow, table: 'my' | 'company') => {
    if (table === 'my') {
      const direction =
        mySortConfig &&
        mySortConfig.key === key &&
        mySortConfig.direction === 'asc'
          ? 'desc'
          : 'asc';
      setMySortConfig({ direction, key, table });
    } else {
      const direction =
        companySortConfig &&
        companySortConfig.key === key &&
        companySortConfig.direction === 'asc'
          ? 'desc'
          : 'asc';
      setCompanySortConfig({ direction, key, table });
    }
  };

  // Get processed data for both tables with their respective sort configs
  const processedMyWorkflows = getProcessedWorkflows(
    myWorkflows,
    filters,
    mySortConfig,
    'my'
  );
  const processedCompanyWorkflows = getProcessedWorkflows(
    companyWorkflows,
    filters,
    companySortConfig,
    'company'
  );
  const hasAnyData =
    processedMyWorkflows.length > 0 || processedCompanyWorkflows.length > 0;

  // Check if data is filtered
  const isFiltered = Object.values(filters).some(
    (value) => value !== null && value !== ''
  );

  return {
    companySortConfig,
    companyWorkflows: processedCompanyWorkflows,
    filters,
    handleSort,
    hasAnyData,
    isFiltered,
    loading,
    mySortConfig,
    myWorkflows: processedMyWorkflows,
    originalCompanyWorkflowsCount: companyWorkflows.length,
    originalMyWorkflowsCount: myWorkflows.length,
    setFilters,
  };
};
